export default "__VITE_ASSET__244c2adb__"